import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contrainer" }
const _hoisted_2 = { class: "kitchen-header" }
const _hoisted_3 = { class: "left-section" }
const _hoisted_4 = { class: "alert-tag" }
const _hoisted_5 = { class: "right-section" }
const _hoisted_6 = { class: "kitchen-body" }

import { onMounted, ref, onUnmounted } from 'vue';
  import KitchenOrderCompent from '@/components/KitchenOrderCompent.vue';
  import KitchenCommodityNewCompent from '@/components/KitchenCommodityNewCompent.vue';
  import {
    OrderDataModel,
    KitchenCommodityCardDataModel,
    DishItemNewModel,
    StoveItemModel,
  } from '@/model/kitchen';
  import { fetchShopList } from '@/service/base';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenView',
  setup(__props) {

  const selectedLocation = ref('24小时餐厅');
  const locationOptions = [
    { text: '24小时餐厅', value: '24小时餐厅' },
    { text: '宴会厅', value: '宴会厅' },
    { text: '五楼中央厨房', value: '五楼中央厨房' },
    { text: '三楼中庭吧台', value: '三楼中庭吧台' },
  ];

  const currentView = ref<'order' | 'dish'>('order');

  const showPicker = ref(false);

  const onConfirm = ({ selectedValues }: { selectedValues: string[] }) => {
    selectedLocation.value = selectedValues[0];
    showPicker.value = false;
  };

  // 创建模拟订单数据
  const mockOrders = [
    {
      id: 1,
      restaurantName: '24小时餐厅',
      tableNumber: 'A1',
      createDate: '2023-09-15 18:30:00',
      orderId: 'ORD123456',
      dishes: [
        { id: 'D1', name: '红烧牛肉面', quantity: 2, note: '少放辣' },
        { id: 'D2', name: '宫保鸡丁饭', quantity: 1, note: '不要花生' },
        { id: 'D3', name: '清蒸鲈鱼', quantity: 1 },
        { id: 'D9', name: '蒜蓉粉丝蒸扇贝', quantity: 4 },
        { id: 'D10', name: '上汤娃娃菜', quantity: 1 },
      ],
      status: '进行中',
      estimatedTime: '15分钟',
      customerName: '张先生',
    },
    {
      id: 2,
      restaurantName: '24小时餐厅',
      tableNumber: 'B2',
      createDate: '2023-09-15 19:15:00',
      orderId: 'ORD123457',
      dishes: [
        { id: 'D4', name: '扬州炒饭', quantity: 3 },
        { id: 'D5', name: '酸辣汤', quantity: 2 },
        { id: 'D11', name: '糖醋排骨', quantity: 1 },
        { id: 'D12', name: '干锅肥肠', quantity: 1 },
      ],
      status: '已完成',
      completedTime: '2023-09-15 19:45:00',
      customerName: '李女士',
    },
    {
      id: 3,
      restaurantName: '宴会厅',
      tableNumber: 'VIP888',
      createDate: '2023-09-15 20:00:00',
      orderId: 'ORD123458',
      dishes: [
        { id: 'D6', name: '北京烤鸭', quantity: 2, note: '片皮要薄' },
        { id: 'D7', name: '鲍鱼捞饭', quantity: 4 },
        { id: 'D8', name: '清炒时蔬', quantity: 2 },
        { id: 'D13', name: '佛跳墙', quantity: 1 },
        { id: 'D14', name: '龙虾刺身', quantity: 1 },
        { id: 'D15', name: '燕窝羹', quantity: 2 },
      ],
      status: '已取消',
      cancelReason: '客户临时有事',
      customerName: '王总',
    },
    {
      id: 4,
      restaurantName: '五楼中央厨房',
      tableNumber: 'C3',
      createDate: '2023-09-15 20:30:00',
      orderId: 'ORD123459',
      dishes: [
        { id: 'D16', name: '黑椒牛排', quantity: 2, note: '七分熟' },
        { id: 'D17', name: '奶油蘑菇汤', quantity: 2 },
        { id: 'D18', name: '凯撒沙拉', quantity: 1 },
      ],
      status: '进行中',
      estimatedTime: '20分钟',
      customerName: '刘先生',
    },
    {
      id: 5,
      restaurantName: '三楼中庭吧台',
      tableNumber: 'D4',
      createDate: '2023-09-15 21:00:00',
      orderId: 'ORD123460',
      dishes: [
        { id: 'D19', name: '莫吉托', quantity: 3 },
        { id: 'D20', name: '长岛冰茶', quantity: 2 },
        { id: 'D21', name: '水果拼盘', quantity: 1 },
      ],
      status: '已完成',
      completedTime: '2023-09-15 21:20:00',
      customerName: '林小姐',
    },
    {
      id: 5,
      restaurantName: '三楼中庭吧台',
      tableNumber: 'D4',
      createDate: '2023-09-15 21:00:00',
      orderId: 'ORD123460',
      dishes: [
        { id: 'D19', name: '莫吉托', quantity: 3 },
        { id: 'D20', name: '长岛冰茶', quantity: 2 },
        { id: 'D21', name: '水果拼盘', quantity: 1 },
      ],
      status: '已完成',
      completedTime: '2023-09-15 21:20:00',
      customerName: '林小姐',
    },
    {
      id: 5,
      restaurantName: '三楼中庭吧台',
      tableNumber: 'D4',
      createDate: '2023-09-15 21:00:00',
      orderId: 'ORD123460',
      dishes: [
        { id: 'D19', name: '莫吉托', quantity: 3 },
        { id: 'D20', name: '长岛冰茶', quantity: 2 },
        { id: 'D21', name: '水果拼盘', quantity: 1 },
      ],
      status: '已完成',
      completedTime: '2023-09-15 21:20:00',
      customerName: '林小姐',
    },
  ];
  const mockDishs: Array<KitchenCommodityCardDataModel> = [
    {
      dishName: '红烧牛肉面',
      isUrgent: true,
      restaurant: '24小时餐厅',
      table: 'A1',
      remaining: 2,
      time: '2023-09-15 18:30:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
    {
      dishName: '宫保鸡丁饭',
      isUrgent: false,
      restaurant: '24小时餐厅',
      table: 'B2',
      remaining: 0,
      time: '2023-09-15 19:15:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
    {
      dishName: '清蒸鲈鱼',
      isUrgent: true,
      restaurant: '宴会厅',
      table: 'VIP888',
      remaining: 1,
      time: '2023-09-15 20:00:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
    {
      dishName: '北京烤鸭',
      isUrgent: false,
      restaurant: '宴会厅',
      table: 'VIP666',
      remaining: 3,
      time: '2023-09-15 20:30:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
    {
      dishName: '黑椒牛排',
      isUrgent: true,
      restaurant: '五楼中央厨房',
      table: 'C3',
      remaining: 2,
      time: '2023-09-15 21:00:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
    {
      dishName: '莫吉托',
      isUrgent: false,
      restaurant: '三楼中庭吧台',
      table: 'D4',
      remaining: 0,
      time: '2023-09-15 21:30:00',
      stoves: ['1号灶台', '2号灶台', '3号灶台', '4号灶台', '5号灶台', '6号灶台'],
    },
  ];
  const stovesData: Array<StoveItemModel> = [
    { id: 1, name: '1号灶台', assignedTasks: 3, availableTasks: 5 },
    { id: 2, name: '2号灶台', assignedTasks: 2, availableTasks: 6 },
    { id: 3, name: '3号灶台', assignedTasks: 4, availableTasks: 4 },
    { id: 4, name: '4号灶台', assignedTasks: 1, availableTasks: 7 },
    { id: 5, name: '5号灶台', assignedTasks: 5, availableTasks: 3 },
    { id: 6, name: '6号灶台', assignedTasks: 0, availableTasks: 8 },
  ];
  const tableData: Array<DishItemNewModel> = [
    {
      name: '宫保鸡丁',
      type: '热菜',
      isUrgent: true,
      location: '宴会厅【8号桌】',
      portions: 2,
      time: '12:30',
    },
    {
      name: '水果拼盘',
      type: '冷菜',
      isUrgent: false,
      location: '包间【3号】',
      portions: 1,
      time: '12:45',
    },
    {
      name: '小笼包',
      type: '点心',
      isUrgent: false,
      location: '大厅【5号桌】',
      portions: 3,
      time: '12:20',
    },
    {
      name: '可乐',
      type: '饮品',
      isUrgent: true,
      location: '宴会厅【10号桌】',
      portions: 4,
      time: '12:35',
    },
    {
      name: '水煮鱼',
      type: '热菜',
      isUrgent: false,
      location: '包间【2号】',
      portions: 2,
      time: '12:50',
    },
    {
      name: '凉拌黄瓜',
      type: '冷菜',
      isUrgent: false,
      location: '大厅【7号桌】',
      portions: 1,
      time: '12:25',
    },
    {
      name: '冰淇淋',
      type: '点心',
      isUrgent: true,
      location: '包间【1号】',
      portions: 1,
      time: '12:40',
    },
  ];

  onMounted(async () => {
    const respShop = await fetchShopList({ pageNum: 1, pageSize: 100, data: {} });
    if (respShop.code === 200) {
      console.log(respShop.result.list);
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_field, {
            modelValue: selectedLocation.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLocation).value = $event)),
            readonly: "",
            clickable: "",
            border: false,
            placeholder: "选择餐厅",
            class: "location-select",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPicker.value = true))
          }, {
            "right-icon": _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "arrow-down",
                class: "arrow-icon"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_icon, { name: "warning" }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "7道菜品，14份", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_button, {
            class: _normalizeClass(['view-btn', { active: currentView.value === 'order' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (currentView.value = 'order'))
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" 订单视图 ", -1)
            ])),
            _: 1,
            __: [7]
          }, 8, ["class"]),
          _createVNode(_component_van_button, {
            class: _normalizeClass(['view-btn', { active: currentView.value === 'dish' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (currentView.value = 'dish'))
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" 菜品视图 ", -1)
            ])),
            _: 1,
            __: [8]
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (currentView.value === 'order')
          ? (_openBlock(), _createBlock(KitchenOrderCompent, {
              key: 0,
              "order-list": mockOrders
            }))
          : (currentView.value === 'dish')
            ? (_openBlock(), _createBlock(KitchenCommodityNewCompent, {
                key: 1,
                "table-data": tableData,
                "stoves-data": stovesData
              }))
            : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"height":"20vh"} }, null, -1))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: showPicker.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showPicker).value = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: locationOptions,
          onConfirm: onConfirm,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (showPicker.value = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})